module.exports = __webpack_public_path__ + "img/20-X5U.975d887.jpg";